const sectionFindAnswerCss = `
[data-type='section-find-answer'] [data-attribute='card-container'] {
  padding: 40px 0;
}

[data-type='section-find-answer'] .wrap-card {
  text-align: center;
}

[data-type='section-find-answer'] .card-icon {
  display: flex;
  justify-content: center;
}

[data-type='section-find-answer'] .card-icon span svg {
  fill: #616161;
  width: 60px;
  height: auto;
}

[data-type='section-find-answer'] .card-title {
  font-size: 24px;
  margin: 7px 0;
  text-align: center;
}

[data-type='section-find-answer'] .card-description {
  margin: 16px 0;
  text-align: center;
}

[data-type='section-find-answer'] .card-btn {
  display: inline-block;
  text-decoration: none;
  font-size: 12px;
  border: solid 1px #3e3e3e;
  padding: 7px 15px;
  border-radius: 25px;
  margin: auto;
}

@container (max-width: 768px) {
  [data-type='section-find-answer'] [data-attribute='card-container'] {
    padding: 16px 0;
  }

  [data-type='section-find-answer'] .card-title {
    font-size: 16px;
  }
}
`;

export default sectionFindAnswerCss;
